import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';
import { gql, Resolver } from '@apollo/client';

interface Args {
    username: string;
    clientId: string;
    userPoolId: string;
}

export const resendConfirmationWithCognito: Resolver = async (
    obj: Record<string, unknown>,
    args: Args,
): Promise<CognitoActionResult> => {
    const { username, clientId, userPoolId } = args;
    const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: clientId,
    });
    const cognitoUser = new CognitoUser({
        Username: username,
        Pool: userPool,
    });

    const resendConfirmation = (): Promise<CognitoActionResult> =>
        new Promise((resolve, reject) => {
            cognitoUser.resendConfirmationCode(err => {
                if (err) {
                    reject(err);
                } else {
                    resolve({ success: true });
                }
            });
        });

    return resendConfirmation();
};

export const RESEND_CONFIRMATION_WITH_COGNITO = gql`
    mutation ResendConfirmationWithCognito(
        $username: String
        $clientId: String
        $userPoolId: String
    ) {
        resendConfirmationWithCognito(
            username: $username
            clientId: $clientId
            userPoolId: $userPoolId
        ) @client
    }
`;
